__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "host";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@material-ui/core", "4.12.4", () => (Promise.all([__webpack_require__.e(1679), __webpack_require__.e(6273), __webpack_require__.e(2125), __webpack_require__.e(2019), __webpack_require__.e(6566), __webpack_require__.e(3884), __webpack_require__.e(3272), __webpack_require__.e(486)]).then(() => (() => (__webpack_require__(56566))))));
			register("@material-ui/icons", "4.11.3", () => (Promise.all([__webpack_require__.e(1679), __webpack_require__.e(4312), __webpack_require__.e(3884), __webpack_require__.e(3272), __webpack_require__.e(3246)]).then(() => (() => (__webpack_require__(94312))))));
			register("@material-ui/styles", "4.11.5", () => (Promise.all([__webpack_require__.e(7283), __webpack_require__.e(3884), __webpack_require__.e(3051)]).then(() => (() => (__webpack_require__(97283))))));
			register("react-dom", "17.0.2", () => (Promise.all([__webpack_require__.e(2548), __webpack_require__.e(3884)]).then(() => (() => (__webpack_require__(2548))))));
			register("react", "17.0.2", () => (__webpack_require__.e(9413).then(() => (() => (__webpack_require__(79413))))));
			register("use-sync-external-store/shim", "1.6.0", () => (Promise.all([__webpack_require__.e(3884), __webpack_require__.e(9871)]).then(() => (() => (__webpack_require__(69871))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};